const dealsChart = {
  chart: {
    type: "bar",
    height: 250,
    plotOptions: {
      bar: {
        // borderRadius: 50,
        borderRadiusApplication: "around",
      },
    },
    colors: ["#FFC38F"],
    xaxis: {
      type: "category",
      group: {
        style: {
          fontSize: "7px",
          fontWeight: 700,
        },
        groups: [
          { title: "2019", cols: 4 },
          { title: "2020", cols: 4 },
        ],
      },
    },
  },
  series: [
    {
      name: "sales",
      colors: ["#FFC38F"],
      data: [
        {
          x: "Inpipeline",
          y: 400,
        },
        {
          x: "Follow Up",
          y: 30,
        },
        {
          x: "Schedule",
          y: 248,
        },
        {
          x: "Conversation",
          y: 470,
        },
        {
          x: "Won",
          y: 470,
        },
        {
          x: "Lost",
          y: 180,
        },
      ],
    },
  ],
};

const lastChart = {
  chart: {
    type: "bar",
    height: 150,

    plotOptions: {
      bar: {
        // borderRadius: 10,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#F96C85"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
  series: [
    {
      data: [400, 122, 250],
    },
  ],
};

const wonChart = {
  chart: {
    type: "bar",
    height: 150,
    plotOptions: {
      bar: {
        // borderRadius: 10,
        horizontal: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#77D882"],
    xaxis: {
      categories: ["Conversation", "Follow Up", "Inpipeline"],
    },
  },
  series: [
    {
      data: [400, 122, 250],
    },
  ],
};

const yearChart = {
  chart: {
    type: "line",
    height: 350,
    stroke: {
      curve: "stepline",
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      align: "left",
    },
    colors: ["#FF902F"],
    markers: {
      hover: {
        sizeOffset: 4,
      },
    },
  },
  series: [
    {
      data: [34, 44, 54, 21, 12, 43, 33, 23, 66, 66, 58],
    },
  ],
};

export { dealsChart, lastChart, wonChart, yearChart };
